export const getLocale = (contentLocale = null) => {
  const isClient = typeof window === 'object'
  if (!isClient) {
    return contentLocale ? contentLocale.slice(0, 2) : null
  }

  return window.location.pathname.slice(1, 3)
}
